module.exports = __webpack_public_path__ + "static/img/bg_play3.7d870753.png";